import React, { Component } from 'react';
import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import muiThemeable from 'material-ui/styles/muiThemeable';

export default muiThemeable()(class SignupSuccessPage extends Component {

  render() {
    return (
      <div>
        <HomeGalleryHeader />
        <div className="SignupSuccessPage"
          style={{
            maxWidth: '700px',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: '5em',
            textAlign: "left",
            boxShadow: "1px 1px 3px #c2c2c2",
            backgroundColor: "#fafafa",
            color: this.props.muiTheme.palette.textColor,
          }}>
          <div
            style={{
              padding: "8px 24px 8px 24px",
            }}>
            <h2>Thanks!</h2>
            <p>
            You're on the waiting list. Expect to hear something from us within a week. In the meantime, do you have any friends who might want to join?
            </p>
          </div>

          <div className="Help"
            style={{
              width: "100%",
              backgroundColor: "#efefef",
              marginTop: "16px",
              paddingTop: "16px",
              textAlign: "center",
              paddingBottom: "16px"
            }}>
            Need Help? Email help@homegalleryproject.com
          </div>
        </div>

        <div className="spacer" style={{marginBottom: "50px"}}></div>

        <HomeGalleryFooter />
    </div>
    );
  }
})



// WEBPACK FOOTER //
// ./src/SignupSuccessPage.js